import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function DailyPicker({ v }) {
  if (!v.showDailyPicker) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.closeDailyPicker}>
        <div className="gp-venster" style={{ "width": "min(440px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "16px", "boxSizing": "border-box" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "2px", "flex": "1 1 auto", "minWidth": "0" }}>
              <div style={{ "fontSize": "19px", "fontWeight": "700", "lineHeight": "1.2" }}>
                Krabbel van morgen
              </div>
              <div style={{ "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-3)", "lineHeight": "1.4" }}>
                Je kiest altijd een dag vooruit. Kies je niets, dan kiest de paal zelf.
              </div>
            </div>
            <button onClick={v.closeDailyPicker} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={22} />
            </button>
          </div>
          <div style={{ "display": "flex", "flexDirection": "column", "gap": "10px" }}>
            {toList(v.dailyPickChoices).map((d, $index) => (
              <React.Fragment key={$index}>
                <button onClick={d?.onPick} className="gp-btn" style={css(d?.rowStyle)}>
                  {' '}
                  <div style={css(d?.thumbStyle)} />
                  {' '}
                  <span style={{ "minWidth": "0", "flex": "1 1 auto" }}>
                    {' '}
                    <span style={{ "display": "block", "fontWeight": "700", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                      <Interp v={d?.title} />
                    </span>
                    {' '}
                    <span style={{ "display": "block", "marginTop": "2px", "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
                      <Interp v={d?.author} />
                    </span>
                    {' '}
                  </span>
                  {' '}
                  {d?.showChosen ? (<>
                    {' '}
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--groen-ink)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" style={{ "flex": "0 0 auto" }}>
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    {' '}
                  </>) : null}
                  {' '}
                </button>
              </React.Fragment>
            ))}
          </div>
          <div style={{ "display": "flex", "flexDirection": "column", "gap": "3px", "fontSize": "12px", "fontWeight": "600", "color": "var(--tekst-2)", "lineHeight": "1.4" }}>
            <span>
              <Interp v={v.dailyPickLine} />
            </span>
            <span style={{ "color": "var(--tekst-3)" }}>
              <Interp v={v.dailyTodayLine} />
            </span>
          </div>
          {v.showClearDaily ? (<>
            <button onClick={v.clearDailyPick} className="gp-btn" style={{ "width": "100%", "justifyContent": "center", "fontSize": "15px", "padding": "12px" }}>
              Laat de paal weer kiezen
            </button>
          </>) : null}
          <button onClick={v.closeDailyPicker} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
            Klaar
          </button>
        </div>
      </div>
      {' '}
    </>
  );
}
